import React from 'react'
import BackgroundIMG from "../assets/img/slider/slider-1.jpg"

function HeroSection() {
  return (
    <div className="hero-section">
        <div className="hero-slider owl-carousel owl-theme">
            <div className="hero-single" style={{ background: `url(${BackgroundIMG})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', }}>
                {/* Overlay for darkening the background */}
                <div className="overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-9 mx-auto">
                            <div className="hero-content text-center">
                                <h6 className="hero-sub-title" data-animation="fadeInUp" data-delay=".25s">Welcome to Serviswift</h6>
                                <h1 className="hero-title" data-animation="fadeInRight" data-delay=".50s">
                                your versatile one stop <span>digital market</span> for all your every day needs
                                </h1>
                                <p data-animation="fadeInLeft" data-delay=".75s">
                                at your fingertips. 
                                With just a few taps you connect to tax hailing, shop online and delivery, order food online and access handy men services.
                                </p>
                                <div className="hero-btn justify-content-center" data-animation="fadeInUp" data-delay="1s">
                                    <a href="/about" className="theme-btn">Learn More <i className="fas fa-arrow-right"></i></a>
                                    <a href="/download" className="theme-btn theme-btn2">Get the App <i className="fas fa-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HeroSection